$(document).ready(function () {

    // Mobile Menu Show Hide
    $('.menu-trigger').click(function () {
        $('.mobilemenu-section').addClass('showed');
    });

    $('.mobilemenu-close').click(function () {
        $('.mobilemenu-section').removeClass('showed');
    });
});

// inputPlaceHolders js
function inputPlaceHolders() {
    $(".input__field").each(function () {
        let currentInput = this;
        if ($(currentInput).val() !== "") {
            $(currentInput).parents('fieldset').addClass("input--filled")
        }
        $(currentInput).off();
        $(currentInput).on('focus', onFocus);
        $(currentInput).on('blur', onBlur);
    });

    function onFocus() {
        $(this).parents('fieldset').addClass('input--filled');
    }

    function onBlur(c) {
        if ($(this).val() === "") {
            $(this).parents('fieldset').removeClass("input--filled")
        }
    }
}
inputPlaceHolders();

$(window).on('load', function () {
    $(".loaderContainer").fadeOut("slow");
});

$(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 160) {
        $("body").addClass("fixedheader");
    } else {
        $("body").removeClass("fixedheader");
    }
});

// Banner Image Path Change on Menu Hover JS
$(document).ready(function() {
    $('body').on('mouseover', '.onhover-banner1 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-h.jpg)");
    }).on('mouseleave', '.onhover-banner1 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-d.jpg)");
    }).on('mouseover', '.onhover-banner2 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-u.jpg)");
    }).on('mouseleave', '.onhover-banner2 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-d.jpg)");
    }).on('mouseover', '.onhover-banner3 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-a.jpg)");
    }).on('mouseleave', '.onhover-banner3 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-d.jpg)");
    }).on('mouseover', '.onhover-banner4 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-e.jpg)");
    }).on('mouseleave', '.onhover-banner4 a', function () {
        $(".banner-img").css("background-image", "url(img/banner-img-h.jpg)");
    });

    $('body').on('mouseover', '.onhover-banner1 a', function () {
        $(this).parent().addClass('nohover');
    }).on('mouseleave', '.onhover-banner1 a', function () {
        $(this).parent().removeClass('nohover');
    }).on('mouseover', '.onhover-banner2 a', function () {
        $(this).parent().addClass('nohover');
    }).on('mouseleave', '.onhover-banner2 a', function () {
        $(this).parent().removeClass('nohover');
    }).on('mouseover', '.onhover-banner3 a', function () {
        $(this).parent().addClass('nohover');
    }).on('mouseleave', '.onhover-banner3 a', function () {
        $(this).parent().removeClass('nohover');
    }).on('mouseover', '.onhover-banner4 a', function () {
        $(this).parent().addClass('nohover');
    }).on('mouseleave', '.onhover-banner4 a', function () {
        $(this).parent().removeClass('nohover');
    });
});

// Button Hover Effect
$(function () {
    $('.btn-effect')
    .on('mouseenter', function (e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find('span').css({ top: relY, left: relX })
    })
    .on('mouseout', function (e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find('span').css({ top: relY, left: relX })
    });
    // $('[href="#"]').click(function () { return false });
});

$(document).ready(function() {
    $(".luxury-slider").slick({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<span class="slick-prev"><img src="img/prevArrow.png"></span>',
        nextArrow: '<span class="slick-next"><img src="img/nextArrow.png"></span>',
        speed: 500,
        autoplaySpeed: 2500,
        responsive: [
            {
                breakpoint: 1365,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

$(document).ready(function () {
    $("form[name='contactusForm']").validate({
        rules: {
            cname: "required",
            cemail: {
                required: true,
                email: true
            },
            cphoneNumber: {
                required: true,
                minlength: 10,
                maxlength: 10,
                digits: true
            }
        },
        messages: {
            cname: "This field is required.",
            cemail: "Please enter a valid email address.",
            cphoneNumber: {
                required: "Please enter valid contact details.",
                minlength: "Your phone number must be 10 digit",
                maxlength: "Your phone number must be 10 digit",
                digit: "only input numeric number"
            }
        },
        submitHandler: function (form) {
            var cname = $("#cname").val();
            var cemail = $("#cemail").val();
            var cphoneNumber = $("#cphoneNumber").val();
            var cmessage = $("#cmessage").val();
            var type = 'Demo';
            $.ajax({
                url: "mailer.php",
                type: "POST",
                data: { name: cname, email: cemail, phoneNumber: cphoneNumber, message: cmessage, type: type },
                beforeSend: function () {
                    $("#contactusSend").prop('disabled', true);
                    $("#contactusSend").html('<i class="fa fa-spinner fa-spin"></i> Sending');
                },
                success: function (data) {
                    var sdata = JSON.parse(data);
                    if (sdata.error) {
                        $("#contactusForm")[0].reset();
                        $("#thankyouModal").modal("show");
                        $("#contactusSend").prop('disabled', false);
                        $("#contactusSend").text('Submit');
                    }
                },
                error: function (data) {
                    console.log("error");
                }
            });
            return false;
        }
    });
    
    $("form[name='enquirenowForm']").validate({
        rules: {
            ename: "required",
            eemail: {
                required: true,
                email: true
            },
            ephoneNumber: {
                required: true,
                minlength: 10,
                maxlength: 10,
                digits: true
            }
        },
        messages: {
            ename: "This field is required.",
            eemail: "Please enter a valid email address.",
            ephoneNumber: {
                required: "Please enter valid contact details.",
                minlength: "Your phone number must be 10 digit",
                maxlength: "Your phone number must be 10 digit",
                digit: "only input numeric number"
            }
        },
        submitHandler: function (form) {
            var ename = $("#ename").val();
            var eemail = $("#eemail").val();
            var ephoneNumber = $("#ephoneNumber").val();
            var emessage = $("#emessage").val();
            var type = 'Demo';
            $.ajax({
                url: "mailer.php",
                type: "POST",
                data: { name: ename, email: eemail, phoneNumber: ephoneNumber, message: emessage, type: type },
                beforeSend: function () {
                    $("#enquirenowSend").prop('disabled', true);
                    $("#enquirenowSend").html('<i class="fa fa-spinner fa-spin"></i> Sending');
                },
                success: function (data) {
                    var sdata = JSON.parse(data);
                    if (sdata.error) {
                        $("#enquirenowForm")[0].reset();
                        $("#enquirenowModal").modal("hide");
                        $("#thankyouModal").modal("show");
                        $("#enquirenowSend").prop('disabled', false);
                        $("#enquirenowSend").text('Submit');
                    }
                },
                error: function (data) {
                    console.log("error");
                }
            });
            return false;
        }
    });

    $("form[name='subscribeForm']").validate({
        //errorElement: 'span',
        errorLabelContainer: '#errors',
        rules: {
            subemail: {
                required: true,
                email: true
            }
        },
        submitHandler: function (form) {
            var subemail = $("#subemail").val();
            $.ajax({
                url: "submailer.php",
                type: "POST",
                data: { subemail: subemail },
                beforeSend: function () {
                    $("#subscribeSend").prop('disabled', true);
                    $("#subscribeSend").html('<i class="fa fa-spinner fa-spin"></i> Sending');
                },
                success: function (data) {
                    var sdata = JSON.parse(data);
                    if (sdata.error) {
                        $("#subscribeForm")[0].reset();
                        $("#subscribeSend").prop('disabled', false);
                        $("#subscribeSend").text('Submit');
                        $("#successmsg").text(sdata.msg);
                        setTimeout(function () { $("#successmsg").hide(); }, 2500);
                    }
                },
                error: function (data) {
                    console.log("error");
                }
            });
            return false;
        }
    });
});